import Icons from './icons';
const Icon = (props) => {
    // Attributes
    const { name, ...rest } = props;
    // Render
    return Icons[props.name](rest);
};
export default Icon;
